<template>
    <div v-if="Object.keys(ev).length !== 0" id="event">
        <div class="card event-details">
            <header class="card-header">
                <p class="card-header-title">
                   {{ locationNames }}: {{ ev.title }}
                    <button class="delete" @click="$emit('close')"></button>
                </p>
            </header>
            <div class="card-content">
                <div class="content">
                    <h3>{{ eventTime }}</h3>

                    <p v-if="ev.extendedProps.description">{{ ev.extendedProps.description }}</p>

                    <p v-if="ev.extendedProps.private_description && canSeePrivateDescription" class="has-text-danger">{{ ev.extendedProps.private_description }}</p>

                    <p v-if="ev.extendedProps.type == 'Offen'">Hallenöffner: {{ ev.extendedProps.owner_name }}</p>

                    <p v-else-if="['Gruppe', 'Sonst', 'Kurs', 'Kindergeburtstag', 'Privat'].includes(ev.extendedProps.type)">Trainer: {{ ev.extendedProps.owner_name }}</p>

                    <p v-if="showRegistrants" class="has-text-danger">
                        Teilnehmer:
                        <ul>
                            <li v-for="(registrant, index) in ev.extendedProps.registrants" :key="`registrant-${index}`">
                            {{ index+1 }}. {{ registrant.name }}
                            </li>
                        </ul>
                    </p>

                    <p v-if="typeof ev.extendedProps.free_spots != 'undefined' && ev.extendedProps.free_spots != 'No limit' && ['Offen', 'Kurs'].includes(ev.extendedProps.type)">Freie Plätze: {{ lang(ev.extendedProps.free_spots) }}</p>

                    <p v-if="ev.extendedProps.info_link">
                        <a :href="ev.extendedProps.info_link" target="_blank">Mehr Info...</a>
                    </p>
                </div>
            </div>
            <footer v-if="showFooter" class="card-footer">
                <a v-if="ev.extendedProps.editable" class="card-footer-item" @click.prevent="$emit('edit')">Bearbeiten</a>
                <a v-if="ev.extendedProps.deletable" class="card-footer-item" @click.prevent="$emit('delete')">Löschen</a>
                <a v-if="isAdmin" class="card-footer-item" @click.prevent="$emit('duplicate')">Duplizieren</a>
                <a v-if="ev.extendedProps.withdrawable" class="card-footer-item" @click.prevent="$emit('withdraw')">Austragen</a>
                <a v-if="ev.extendedProps.enlistable" class="card-footer-item" @click.prevent="$emit('enlist')">Eintragen</a>
                <a v-if="ev.extendedProps.registerable" class="card-footer-item" @click.prevent="$emit('register')">Eintragen</a>
                <a v-if="ev.extendedProps.deregisterable" class="card-footer-item" @click.prevent="$emit('deregister')">Austragen</a>
            </footer>
        </div>
    </div>
</template>

<script>
export default {
    name: "event",
    props: {
        isAdmin: {
            required: true,
            default: false
        },
        ev: {
            required: true
        },
        l: {
            type: String,
            default: 'en'
        }
    },
    data() {
        return {};
    },
    computed: {
        eventTime() {
            if (!this.ev.start || !this.ev.end) {
                return "";
            }

            let start = this.ev.start;
            let end = this.ev.end;

            let formattedTime =
                start.toLocaleString(this.l, {
                    day: "numeric",
                    month: "long",
                    hour: "2-digit",
                    minute: "2-digit"
                }) +
                " - ";

            if (
                start.getFullYear() === end.getFullYear() &&
                start.getMonth() === end.getMonth() &&
                start.getDate() === end.getDate()
            ) {
                formattedTime +=
                    end.toLocaleString(this.l, {
                        hour: "2-digit",
                        minute: "2-digit"
                    });
            } else {
                formattedTime +=
                    end.toLocaleString(this.l, {
                        day: "numeric",
                        month: "long",
                        hour: "2-digit",
                        minute: "2-digit"
                    });
            }

            return formattedTime;
        },
        canSeePrivateDescription() {
            if (this.isAdmin) {
                return true;
            }
            let userIds = _.map(this.ev.extendedProps.users, 'id');
            return userIds.includes(this.$auth.user.id);
        },
        showRegistrants() {
            if (!this.ev.extendedProps.registrants || this.ev.extendedProps.registrants.length == 0) {
                return false;
            }
            if (this.isAdmin) {
                return true;
            }
            let userIds = _.map(this.ev.extendedProps.users, 'id');
            return userIds.includes(this.$auth.user.id);
        },
        showFooter() {
            return this.ev.extendedProps.editable || this.ev.extendedProps.deletable || this.ev.extendedProps.withdrawable || this.ev.extendedProps.enlistable || this.ev.extendedProps.registerable || this.ev.extendedProps.deregisterable;
        },
        locationNames() {
            return this.ev.extendedProps.locations.map(l => l.name).join(' & ');
        },
    },
};
</script>

<style>
.event-details {
    margin-bottom: 30px;
}
.card-header-title {
    justify-content: space-between;
}
</style>
